<template>
  <div class="col-lg-6 col-md-12 col-xs-12 px-6">

    <div class="dummy-rank-container cl-card" v-if="busy">
      <div class="row dummy-body">
        <div class="col-6">
          <div class="dummy-title"></div>
          <div class="dummy-current-score"></div>
        </div>
        <div class="col-6">
          <div class="dummy-title"></div>
          <div class="dummy-current-score"></div>
        </div>
      </div>
    </div>

    <div class="rank-container cl-card" v-else>
      <div class="row">
        <div class="col-6">
          <div class="rank">
            <div class="title">TOP
              <template v-if="isSchoolTotal">
                <strong>{{ rateScore(schoolRate) || 0 }}%</strong>
              </template>
              <strong v-else>-%</strong>
            </div>
            <div class="subtitle">
              <template v-if="isSchoolTotal">{{ schoolName }} {{ $t('common.standard') }}</template>
              <template v-else>{{ $t('common.standard_before_update') }}</template>
            </div>
            <div class="school-icon-container">
              <div class="background-icon">
                <img :src="'/static/images/ic-level-school-bg.svg'" alt="school">
                <div class="icon"
                  v-if="isSchoolTotal"
                  :style="{ 'margin-top': changedIcon(schoolRate).margin, 'height': changedIcon(schoolRate).height }">
                  <img :src="'/static/images/ic_level_school_bg.svg'" alt="school">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="rank">
            <div class="title">TOP 
              <template v-if="isGradeTotal">
                <strong>{{ rateScore(gradeRate) || 0 }}%</strong>
              </template>
              <strong v-else>-%</strong>
            </div>
            <div class="subtitle">
              <template v-if="isGradeTotal">{{ $t('proficiency.standard') }}</template>
              <template v-else>{{ $t('common.standard_before_update') }}</template>
            </div>
            <div class="grade-icon-container">
              <div class="background-icon">
                <img :src="'/static/images/ic-level-total-bg.svg'" alt="grade">
                <div class="icon"
                  v-if="isGradeTotal"
                  :style="{ 'margin-top': changedIcon(gradeRate).margin, 'height': changedIcon(gradeRate).height }">
                  <img :src="'/static/images/ic-level-total-100.svg'" alt="grade">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { round } from 'lodash';

  export default {
    name: 'cat-rank',

    data() {
      return {
        busy: false,
      };
    },

    props: [
      'selectedSubjectId',
    ],

    computed: {
      ...mapGetters({
        filterProficiencyRank: 'getFilterProficiencyRank',
        schoolName: 'getSchoolName',
        isSchoolTotal: 'isSchoolTotal',
        isGradeTotal: 'isGradeTotal',
        schoolRate: 'getSchoolRate',
        gradeRate: 'getGradeRate',
        changedSchoolRate: 'getChangedSchoolRate',
        changedGradeRate: 'getChangedGradeRate',
        isParentUser: 'isParentUser',
        childProficiencyRank: 'getChildProficiencyRank',
        selectedChildId: 'getSelectedChildId',
      }),

    },

    methods: {
      ...mapActions([
        'fetchFilterProficiencyRank',
        'fetchChildProficiencyRank',
      ]),

      changedIcon(rate) {
        const total = 76;
        const height = (total * rate) / 100;
        return {
          margin: `${height}px`,
          height: `${total - height}px`,
        };
      },

      rateScore(score) {
        return round(Math.abs(score), 1);
      },
    },

    beforeMount() {
      if (!this.isParentUser) {
        this.busy = true;
        this.fetchFilterProficiencyRank()
          .then(() => {
            this.busy = false;
          });
      }
    },

    watch: {
      selectedSubjectId(selected) {
        const filters = {};
        if (selected !== 0) {
          filters.subject_id = selected;
        }

        // Support Student
        if (!this.isParentUser && !this.filterProficiencyRank[selected]) {
          this.busy = true;
          this.fetchFilterProficiencyRank(filters)
            .then(() => {
              this.busy = false;
            });
        }

        // Support Parent
        if (this.isParentUser && !this.childProficiencyRank[selected]) {
          this.busy = true;
          filters.child_id = this.selectedChildId;
          this.fetchChildProficiencyRank(filters)
            .then(() => {
              this.busy = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  $dummy-background-color: rgba(0, 0, 0, 0.1);

  .rank-container {
    .rank {
      padding: 14px 14px 0 14px;
      height: 146px;
      position: relative;

      .title {
        color: rgba(0, 0, 0, 0.54);
        padding: 6px 0 6px 0;
        font-size: 14px;
        font-weight: bold;

        strong {
          font-size: 20px;
          color: #00c896;
        }

        .changed-score {
          font-size: 14px;
          display: inline-block;

          @media (max-width: 375px) {
            font-size: 12px;
          }

          .icon {
            vertical-align: initial;
          }
        }
      }

      .subtitle {
        font-size: 14px;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.4);

        @media (max-width: 375px) {
          font-size: 12px;
        }
      }

      .school-icon-container {
        position: absolute;
        width: 98px;
        right: 6px;
        height: 76px;
        bottom: 0px;

        .background-icon {
          overflow: hidden;
          height: 76px;
          width: 98px;
          position: relative;
          
          img {
            width: 98px;
            height: 76px;
            position: absolute;
            bottom: 0;
          }
          .icon {
            height: 20px;
            margin-top: 56px;
            overflow: hidden;
            position: relative;

            img {
              width: 98px;
              height: 76px;
              position: absolute;
              bottom: 0;
            }
          }
        }
      }

      .grade-icon-container {
        position: absolute;
        width: 74px;
        right: 6px;
        height: 76px;
        bottom: 0px;

        .background-icon {
          overflow: hidden;
          height: 76px;
          width: 74px;
          position: relative;
          
          img {
            width: 74px;
            height: 76px;
            position: absolute;
            bottom: 0;
          }
          .icon {
            height: 20px;
            margin-top: 56px;
            overflow: hidden;
            position: relative;

            img {
              width: 74px;
              height: 76px;
              position: absolute;
              bottom: 0;
            }
          }
        }
      }

    }
  }

  .dummy-rank-container {
    padding: 14px;
    height: 146px;
    
    .dummy-title {
      background-color: $dummy-background-color;
      padding: 8px;
      width: 20%;
    }

    .dummy-body {
      .dummy-current-score {
        background-color: $dummy-background-color;
        width: 60%;
        padding: 8px;
        margin: 8px 0px 8px 0px;
      }

      .dummy-progress-bar {
        width: 50%;
        background-color: $dummy-background-color;
        padding: 8px;
        margin: 8px 0px 8px 0px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// CatRank.vue?972d722e